import React from 'react';
import styled from 'styled-components';
import { colors } from '../StylesGlobales/Colors';
import { FaArrowCircleUp } from 'react-icons/fa';

const Return = (props) => {
  const clickItem = (item) => {
    document.getElementById(item).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={props.className}>
      <button className="arrowButton" onClick={() => clickItem('start')}>
        <FaArrowCircleUp className="icon" />
      </button>
    </div>
  );
};

export default styled(Return)`
  text-align: end;

  .icon {
    font-size: 25px;
  }
  .arrowButton {
    color: #054dae;
    box-shadow: ${colors.BOX_SHADOW_BUTTON};

    background: ${colors.TEXT_GRADIENT_PURPLE};
    padding: 9px 11px;
    border-radius: 999px;
    border: none;
    margin: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }
`;
